import api from "./Api";

class RevendaService {
  GetRevenda(payload) {
    return api.get("/v1/revenda/" + payload).then((response) => {
      return response.data;
    });
  }

  PostRevenda(payload) {
    return api.post("/v1/revenda/", payload).then((response) => {
      return response.data;
    });
  }

  PutRevenda(payload) {
    return api.put("/v1/revenda/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteRevenda(payload) {
    return api.delete("/v1/revenda/" + payload).then((response) => {
      return response.data;
    });
  }

  GetRevendaOData(payload) {
    return api.get("/OData/revenda" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new RevendaService();
